/* eslint-disable import/prefer-default-export */
export const searchMatch = (search = '', properties: string[]) => {
  const terms = search.split(' ').map((t) => new RegExp(t, 'igm'));
  const bundle = properties.join(' ');
  return terms.map((t) => (bundle.search(t) !== -1))
    .reduce((acc, val) => acc && val, true);
};
